import { Component, Input, ViewChild, ViewContainerRef, ComponentRef, OnDestroy, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { BaseControl, SubFormularioControl, TypeChecker } from '../../../shared';
import { DynamicForm } from '../../../shared/classes/dynamic-form';
import { FormCreatorService, IFormEvent, IFormEventType, IFormOptions } from '../../../services';
import { SubFormularioControlComponent } from './sub-formulario-control.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sub-formularios-container',
  standalone: true,
  imports: [ButtonModule, TranslateModule, CommonModule],
  styles: `
    :host {
      display: contents;
    }
  `,
  template: `
  <ng-container #subFormContainer></ng-container>

  @if(typeChecker.isSubFormulario(control)){
    @if(!viewAnswerMode){
      <button pButton type="button" *ngIf="control.removeAddBtn !== true"
        [label]="'msg.agregarSubformulario' | translate"
        icon="pi pi-plus" class="p-button-sm w-full p-button-outlined"
        (click)="addNewSubform()"></button>
    }
  }
  `
})
export class SubFormulariosContainerComponent implements OnDestroy, OnInit {
  @Input() control !: BaseControl<any>;
  @ViewChild('subFormContainer', { read: ViewContainerRef, static: true })
  private _subFormContainer !: ViewContainerRef;
  private _subformId: number = 0;
  private _subforms: Map<number, DynamicForm> = new Map<number, DynamicForm>();
  private _toLoad !: any[];
  viewAnswerMode: boolean = false;

  typeChecker = TypeChecker;

  constructor(private readonly fc: FormCreatorService) {
  }

  ngOnInit(): void {
    this._toLoad = this.fc.getSubformulariosToLoad(this.control.name);
    if (this._toLoad && this._toLoad.length > 0) {
      this.viewAnswerMode = true;
      this._toLoad.forEach((data) => {
        this.addNewSubform(data);
      });
    }
    this.fc.formEventNewSubFormSubject.subscribe((event) => this.addNewSubform(event));
  }

  ngOnDestroy(): void {
    this.fc.Form.removeSubForm(this.control.name);
  }

  addNewSubform(respuestaToLoad?: any) {
    this._subformId++;
    const componentRef: ComponentRef<SubFormularioControlComponent> = this._subFormContainer.createComponent(SubFormularioControlComponent);
    componentRef.instance.control = this.control;
    componentRef.instance.index = this._subformId;
    componentRef.instance.radicado = this.fc.radicado;
    //Set options for the subform
    if (respuestaToLoad) {
      const options = {
        enableSubmit: false,
        isDesigner: false,
        viewAnswerMode: true
      } as IFormOptions;
      componentRef.instance.fc.setOptions(options);
      //Subscribe to download file event
      componentRef.instance.fc.downloadFileEvent.subscribe(([radicado, fileId, fileName, saveFile]: [string, string, string, boolean]) => {
        //we use the parent fc to emit the event
        this.fc.emitDownloadSubformFileEvent(radicado, fileId, fileName, saveFile);
      });
    }
    componentRef.instance.formLoaded.subscribe((dynamicForm) => {
      this._subforms.set(this._subformId, dynamicForm);
      if (respuestaToLoad) {
        componentRef.instance.fc.loadRespuesta(JSON.stringify(respuestaToLoad));
      }
      this.updateControlSubforms();

      const event: IFormEvent = {
        eventType: IFormEventType.add,
        form: this.fc.Form,
        control: this.control,
        data: { form: dynamicForm }
      }
      this.fc.emitFormEvent(event);

      this.setFormControlValue();
    });
    componentRef.instance.onRemoveForm.subscribe((id) => {
      const removedForm = this._subforms.get(id);
      this._subforms.delete(id);
      componentRef.destroy();
      this.updateControlSubforms();

      const event: IFormEvent = {
        eventType: IFormEventType.remove,
        form: this.fc.Form,
        control: this.control,
        data: { form: removedForm }
      }
      this.fc.emitFormEvent(event);
      this.setFormControlValue();
    });
  }

  private setFormControlValue() {
    if (this._subforms.size > 0) {
      this.control.FormControl.setValue(true);
    } else {
      this.control.FormControl.setValue(null);
    }
  }

  updateControlSubforms(): void {
    const subFormsArray = Array.from(this._subforms.values());
    this.fc.Form.addSubForm(this.control.name, subFormsArray);
  }
}
